import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';
import { Button } from 'react-bootstrap';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';

// display terms and conditions of current marketplace (checkout)
class ModalOrderProcessingContract extends React.Component {
  render() {
    const {
      intl: { messages },
      show,
      close,
      cmsPage,
      formStatus,
    } = this.props;

    return (
      <Modal show={show} onHide={close} bsSize="lg" class="full-width">
        <Modal.Header closeButton>
          <Modal.Title>{messages.order_processing_contract}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Todo ModalOrderProcessingContract prüfe api und dataname */}
          <Data dataName="cmsSystemPageOrderProcessingContract" url="/api/pages/orderprocessingcontract.json" data={cmsPage} />
          <div class="themed">
            {cmsPage.pending ? <Loader /> :
              <div>
                <p>{messages.accept_order_processing_contract_before_continuing}</p>
                <CmsPage data={cmsPage.data} doUpdateActiveCms={false} />
                <div className="m-t-20 text-right">
                  <Button bsStyle="primary" bsSize="lg" disabled={formStatus.pending} onClick={this.props.onSubmit}>
                    {formStatus.pending ? <i className="fa fa-circle-notch fa-spin"/> : null} {messages.i_accept}
                  </Button>
                </div>
              </div>
            }
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    cmsPage: state.data.cmsSystemPageOrderProcessingContract,
    formStatus: state.formStatus.clientAcceptOrderProcessingContract,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: () => {
      formStatusDispatchHelper('clientAcceptOrderProcessingContract', '/api/clientacceptorderprocessingcontracts.json', {}, 'post', dispatch);
    },
  };
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(ModalOrderProcessingContract)));
